export function questionTotalNumber() {
  const questionEasyNumber = Number($('#questionEasyNumber').val());
  const questionIntermediateNumber = Number($('#questionIntermediateNumber').val());
  const questionHardNumber = Number($('#questionHardNumber').val());
  const total = questionEasyNumber + questionIntermediateNumber + questionHardNumber;
  $('#questionTotalNumber').val(total);
}
export function getGroups(data) {
  let dataTxtArr = [];
  $(data).find('.groupViewName').each(function () {
    const txt = $(this).text();
    dataTxtArr.push(txt);
  });
  dataTxtArr.forEach(function (txt) {
    const option = $(`<option>${txt}</option>`);
    $('#assessmentGroupOption').append(option);
  });
}
export function getGroupsMembers() {
  $('.assessmentViewGroupMembers').children().hide(200, function () {
    $(this).remove();
  });
  const clickedOption = $(this).text();
  $.get('./groups.html', function (data) {
    const dataTxt = $(data).find(`.groupViewName:contains(${clickedOption})`).next().children();
    // $('.assessmentViewGroupMembers').append(dataTxt);
    $(dataTxt).appendTo('.assessmentViewGroupMembers').fadeIn(300);
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/assessment/_assessment.js
// module id = 23
// module chunks = 0